module.exports = __webpack_public_path__ + "static/media/IMG_8763.6a2bf6ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8763.jpg
// module id = 163
// module chunks = 0